module.exports = "https://static-www.niulinkcloud.com/_next/static/media/activity.51863d8e7734800ad809635ba0c8dd4f.jpg";